// extracted by css-extract-rspack-plugin
export default {"avatar":"FeaturedTopic-module__avatar__tdUEo"};